<div class="">
	<h3 class="mb-4">Forgot Password</h3>
	<div class="row">
		<div class="col">
			<h4>Reset Password</h4>
			<form [formGroup]="form" (ngSubmit)="onSubmit()" class="mb-3">
				<div class="alert alert-danger" *ngIf="message">
					{{message}}
				</div>
				<div class="form-floating-underline mb-4" [ngClass]="{'active': form.get('password')?.value}">
					<input
						formControlName="password"
						name="password"
						[type]="showPassword ? 'text' : 'password'"
						id="passwordInput"
						placeholder=" "
						required/>
					<label for="passwordInput">Password</label>
					<a class="text-secondary text-decoration-none position-absolute end-0 top-50 translate-middle-y me-3" (click)="showPassword = !showPassword">
						<i *ngIf="showPassword"  nz-icon nzType="eye" nzTheme="outline" style="font-size: 1.3em"></i>
						<i *ngIf="!showPassword" nz-icon nzType="eye-invisible" nzTheme="outline" style="font-size: 1.3em"></i>
					</a>
				</div>
				<div class="form-floating-underline mb-4" [ngClass]="{'active': form.get('confirmPassword')?.value}">
					<input
						formControlName="confirmPassword"
						name="confirmPassword"
						[type]="showConfirmPassword ? 'text' : 'password'"
						id="confirmPasswordInput"
						placeholder=" "
						required/>
					<label for="passwordInput">Confirm Password</label>
					<a class="text-secondary text-decoration-none position-absolute end-0 top-50 translate-middle-y me-3" (click)="showConfirmPassword = !showConfirmPassword">
						<i *ngIf="showConfirmPassword"  nz-icon nzType="eye" nzTheme="outline" style="font-size: 1.3em"></i>
						<i *ngIf="!showConfirmPassword" nz-icon nzType="eye-invisible" nzTheme="outline" style="font-size: 1.3em"></i>
					</a>
				</div>
				<div class="text-danger" *ngIf="showPasswordsDontMatchLabel">Passwords don't match</div>
				<div class="btn-group w-100">
					<button class="w-25 btn btn-outline-secondary" [disabled]="submitting == true" (click)="goBack()">Back</button>
					<button class="w-75 btn btn-primary" [disabled]="form.invalid" *ngIf="submitting == false">Enter Password</button>
					<button class="w-75 btn btn-primary" [disabled]="true" *ngIf="submitting == true">
						<i nz-icon nzType="loading" nzTheme="outline"></i>
					</button>
				</div>
			</form>
		</div>
		<div class="col small-text">
			<h5 class="mb-2">🔐 Password Requirements</h5>
			<ul class="mb-0">
				<li><strong>Length:</strong> Must be <strong>8–16 characters</strong> long</li>
				<li><strong>Spaces:</strong> <span class="text-danger">Not allowed</span></li>
				<li><strong>Sequences:</strong> Avoid common sequences like <code>abc</code>, <code>123</code>, <code>qwe</code></li>
				<li><strong>Repetition:</strong> No character repeated <strong>4 or more times in a row</strong></li>
				<li>
				<strong>Character types:</strong> Must include at least <strong>3 of the following 4</strong>:
				<ul>
					<li>🔢 A digit (e.g., <code>0–9</code>)</li>
					<li>🔣 A special character (e.g., <code>#</code>, <code>!</code>, <code>%</code>, <code>+</code>)</li>
					<li>🔠 An uppercase letter (e.g., <code>A–Z</code>)</li>
					<li>🔡 A lowercase letter (e.g., <code>a–z</code>)</li>
				</ul>
				</li>
			</ul>
		</div>
	</div>
</div>
